export function drawRoadAutotileImage({
  ctx,
  img,
  tileX,
  tileY,
  tileSize,
  rotation,
}: {
  ctx: CanvasRenderingContext2D;
  img: HTMLImageElement;
  tileX: number;
  tileY: number;
  tileSize: number;
  rotation: number;
}): void {
  const px = tileX * tileSize;
  const py = tileY * tileSize;
  ctx.imageSmoothingEnabled = false;
  if (rotation === 0) {
    ctx.drawImage(img, px, py, tileSize, tileSize);
    return;
  }
  ctx.save();
  ctx.translate(px + tileSize / 2, py + tileSize / 2);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.drawImage(img, -tileSize / 2, -tileSize / 2, tileSize, tileSize);
  ctx.restore();
}
